<template>
  <card
    v-loading="isCompanyFetching || isTenantContactListFetching"
    el-loading-background="fixed-white"
    el-loading-color="brand-secondary"
    el-loading-size="48"
    :title="$t('profile.company.title')"
  >
    <template
      v-if="shouldShowAAN"
      #tip
    >
      <el-tag
        type="inactive"
        small
        class="aan-tag mr-8"
      >
        {{ `AAN: ${company.aan}` }}
      </el-tag>
      <el-tooltip
        :content="$t('profile.company.aan.description')"
      >
        <el-icon
          name="i-info-circle-small--16"
          color="fixed-light"
        />
      </el-tooltip>
    </template>
    <template #action-bar>
      <el-button
        v-if="!isEditFormShown"
        type="ghost"
        icon="i-pencil-o--16"
        :disabled="!isEditModeEnabled"
        data-test-id="company-card.button-edit"
        @click="showEditForm"
      >
        {{ $t('action.edit') }}
      </el-button>
    </template>
    <template v-if="isEditFormShown">
      <company-edit-form
        :value="company"
        :tenant-contacts="tenantContactList"
        @submit="hideEditForm"
        @cancel="hideEditForm"
      />
    </template>
    <template v-else>
      <company-property-list
        :value="company"
        :tenant-contacts="tenantContactList"
      />
    </template>
  </card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/app/components/Card';
import CompanyEditForm from '@/app/components/profile/CompanyEditForm';
import CompanyPropertyList from '@/app/components/profile/CompanyPropertyList';

export default {
  name: 'CompanyCard',
  components: {
    Card,
    CompanyEditForm,
    CompanyPropertyList
  },
  data() {
    return {
      isEditFormShown: false
    };
  },
  computed: {
    ...mapGetters('app', [
      'company',
      'isEditModeEnabled',
      'tenantContactList',
      'isCompanyFetching',
      'isTenantContactListFetching',
      'isDirectPartnerFetching',
      'isDirectPartner'
    ]),
    shouldShowAAN() {
      return !!this.company.aan && !this.isDirectPartnerFetching && this.isDirectPartner;
    }
  },
  methods: {
    showEditForm() {
      this.isEditFormShown = true;
    },
    hideEditForm() {
      this.isEditFormShown = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@uikit/ui-kit/themes/acronis/src/common/variables';

.aan-tag {
  letter-spacing: 1px;
}
</style>
